import { CheckIcon } from '@icons/CheckIcon';
import { WarningIcon } from '@icons/WarningIcon';
import type { ReactNode } from 'react';
import {
  CheckIconSpan,
  Container,
  ErrorMessage,
  FormLabel,
  Input,
  MainLabel,
  WarningIconSpan,
} from '../../../styles';
import type { IEmailInput } from '../../types';
import { getLabel } from './helper';

export const EmailInput = ({
  field,
  formikProps,
  count,
}: {
  field: IEmailInput;
  formikProps: any;
  count: number;
}): ReactNode => {
  const error = formikProps.errors[field.fieldName];
  const hasError = error || (field.required && !formikProps.values[field.fieldName] && count > 1);
  const hasValue = !!formikProps.values[field.fieldName];

  return (
    <Container className={field?.hidden ? 'hidden' : ''} aria-hidden={!!field?.hidden}>
      <MainLabel>
        <FormLabel tag="span" type="lead" className="text-gray-500">
          {getLabel(field)}
        </FormLabel>
        <Input
          type="email"
          name={field.fieldName}
          onChange={formikProps.handleChange}
          value={formikProps.values[field.fieldName]}
          placeholder={field.placeholderText}
          data-test={`email-${field.fieldName}`}
          autoComplete="email"
          $hasError={!!error}
          aria-required={!!field.required}
        />

        {!hasError && hasValue && (
          <CheckIconSpan>
            <CheckIcon />
          </CheckIconSpan>
        )}
        {hasError && (
          <WarningIconSpan>
            <WarningIcon />
          </WarningIconSpan>
        )}
      </MainLabel>
      {hasError && (
        <ErrorMessage data-test={`email-${field.fieldName}-error`}>
          {field.requiredErrorMessage}
        </ErrorMessage>
      )}
    </Container>
  );
};
